import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgFilledCheckmark = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" fill="#239F25" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.995 8.04a.49.49 0 0 0-.14-.343l-.687-.686a.49.49 0 0 0-.686 0l-3.31 3.315-1.484-1.489a.49.49 0 0 0-.687 0l-.686.687a.49.49 0 0 0 0 .686l2.513 2.513a.49.49 0 0 0 .686 0l4.34-4.34a.49.49 0 0 0 .142-.343Z"
        fill="#fff"
      />
    </svg>
  );
};
export default SvgFilledCheckmark;
